import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Footer_ScreenContext } from "../footer/footer-context";

declare let window: any;

export interface IProfile_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IProfile_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  B2BGetRolesById: any[];
  B2BGetRolesById_dummy: any[];
  PhotosFromGallery: any[];
  PhotosFromGallery_dummy: any[];
  SetProfilePhoto: number;
  SetProfilePhoto_dummy: number;
  DeleteProfileImage: number;
  DeleteProfileImage_dummy: number;
  isComp265355Enabled: "enabled" | "disabled";
  isComp165336Enabled: "enabled" | "disabled";
  isComp557255Enabled: "enabled" | "disabled";
  isCompprofile_939572AuthorizationVisible: "visible" | "hidden";
  isCompprofile_904101AuthorizationVisible: "visible" | "hidden";
  isCompprofile_697287AuthorizationVisible: "visible" | "hidden";
  isCompprofile_505705AuthorizationVisible: "visible" | "hidden";
}

export class Profile_ScreenBase extends React.PureComponent<
  IProfile_ScreenProps,
  any
> {
  static contextType = Footer_ScreenContext;
  declare context: React.ContextType<typeof Footer_ScreenContext>;

  ml = [
    {
      Id: "782add75-a2c8-e698-bccf-af29bb1e9b35",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [
        {
          Id: 7187,
          PropertyName: "value",
          Value: "Profilim",
          TagName: "Label1_value",
        },
        {
          Id: 904101,
          PropertyName: "value",
          Value: "Müşteri",
          TagName: "Label2_value",
        },
        {
          Id: 505705,
          PropertyName: "value",
          Value: "Admin",
          TagName: "Label3_value",
        },
        {
          Id: 287513,
          PropertyName: "value",
          Value: "Müşteri Kodu",
          TagName: "Label4_value",
        },
        {
          Id: 265355,
          PropertyName: "placeholder",
          Value: "Müşteri Kodu",
          TagName: "TextInput1_placeholder",
        },
        {
          Id: 248012,
          PropertyName: "value",
          Value: "Ad Soyad",
          TagName: "Label6_value",
        },
        {
          Id: 165336,
          PropertyName: "placeholder",
          Value: "Ad Soyad",
          TagName: "TextInput3_placeholder",
        },
        {
          Id: 561493,
          PropertyName: "value",
          Value: "Kullanıcı Adı",
          TagName: "Label5_value",
        },
        {
          Id: 557255,
          PropertyName: "placeholder",
          Value: "Kullanıcı Adı",
          TagName: "TextInput2_placeholder",
        },
        {
          Id: 91007860,
          PropertyName: "d1bb6316-3119-9e61-9c0a-612641422869_confirmation",
          Value: "Profilinizi Silmek İstiyor musunuz?",
          TagName: "DeleteProfileImage_confirmation",
          IsConfirmation: true,
        },
      ],
    },
    {
      Id: "c2176777-61f9-4e18-a818-fb50309cde20",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 904101,
          PropertyName: "value",
          Value: "Customer",
          TagName: "Label2_value",
        },
        {
          Id: 505705,
          PropertyName: "value",
          Value: "Admin",
          TagName: "Label3_value",
        },
        {
          Id: 287513,
          PropertyName: "value",
          Value: "Customer Code",
          TagName: "Label4_value",
        },
        {
          Id: 265355,
          PropertyName: "placeholder",
          Value: "Customer Code",
          TagName: "TextInput1_placeholder",
        },
        {
          Id: 248012,
          PropertyName: "value",
          Value: "Name Surname",
          TagName: "Label6_value",
        },
        {
          Id: 165336,
          PropertyName: "placeholder",
          Value: "Name Surname",
          TagName: "TextInput3_placeholder",
        },
        {
          Id: 561493,
          PropertyName: "value",
          Value: "User name",
          TagName: "Label5_value",
        },
        {
          Id: 557255,
          PropertyName: "placeholder",
          Value: "User name",
          TagName: "TextInput2_placeholder",
        },
        {
          Id: 96736497,
          PropertyName: "d1bb6316-3119-9e61-9c0a-612641422869_confirmation",
          Value: "Do you want to delete your profile?",
          TagName: "DeleteProfileImage_confirmation",
          IsConfirmation: true,
        },
      ],
    },
    {
      Id: "7f454339-3750-46b9-b95a-7fcf112eaedd",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 7187, PropertyName: "value", Value: "Profilim" },
        { Id: 904101, PropertyName: "value", Value: "Müşteri" },
        { Id: 505705, PropertyName: "value", Value: "Admin" },
        { Id: 287513, PropertyName: "value", Value: "Müşteri Kodu" },
        { Id: 265355, PropertyName: "placeholder", Value: "Müşteri Kodu" },
        { Id: 248012, PropertyName: "value", Value: "Ad Soyad" },
        { Id: 165336, PropertyName: "placeholder", Value: "Ad Soyad" },
        { Id: 561493, PropertyName: "value", Value: "Kullanıcı Adı" },
        { Id: 557255, PropertyName: "placeholder", Value: "Kullanıcı Adı" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.profile_265355_value_kuikaTextInputRef = React.createRef();
    this.profile_165336_value_kuikaTextInputRef = React.createRef();
    this.profile_557255_value_kuikaTextInputRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      B2BGetRolesById: [],
      PhotosFromGallery: [],
      SetProfilePhoto: 0,
      DeleteProfileImage: 0,
      isComp265355Enabled: "disabled",
      isComp165336Enabled: "disabled",
      isComp557255Enabled: "disabled",
      isCompprofile_939572AuthorizationVisible: "visible",
      isCompprofile_904101AuthorizationVisible: "visible",
      isCompprofile_697287AuthorizationVisible: "visible",
      isCompprofile_505705AuthorizationVisible: "visible",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("profile", "footer_screen");
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.ProfilePageInit();
    } else if (
      !this.context?.callCallbackFunction ||
      this.context?.isMasterPageInitLoaded
    ) {
      this._prevMasterPageInitLoaded =
        this.context?.isMasterPageInitLoaded ?? false;
      await this.ProfilePageInit();
    }
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompprofile_939572AuthorizationVisible",
      ["b0582dca-d15e-93c3-7cb1-20c8fd8b886a", "B2BCustomer"]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompprofile_904101AuthorizationVisible",
      ["b0582dca-d15e-93c3-7cb1-20c8fd8b886a", "B2BCustomer"]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompprofile_697287AuthorizationVisible",
      ["af27e181-8ee4-f93d-64a9-9e2b5e056d6c", "B2BAdmin"]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompprofile_505705AuthorizationVisible",
      ["af27e181-8ee4-f93d-64a9-9e2b5e056d6c", "B2BAdmin"]
    );

    KuikaAppManager.calculateAndSetBodyHeight("profile", "footer_screen");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("profile", "footer_screen");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.ProfilePageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.ProfilePageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      profile_299355_value:
        this.state.B2BGetRolesById?.at?.(0)?.profilePhoto ?? undefined,
      profile_265355_value:
        this.state.B2BGetRolesById?.at?.(0)?.customerCode ?? undefined,
      profile_165336_value:
        this.state.B2BGetRolesById?.at?.(0)?.fullName ?? undefined,
      profile_557255_value:
        this.state.B2BGetRolesById?.at?.(-1)?.userName ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  ProfilePageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Profile/ProfilePageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BGetRolesById = result?.data.b2BGetRolesById;
    formVars.profile_299355_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BGetRolesById !== undefined
        ? stateVars.B2BGetRolesById?.length > 0
          ? stateVars.B2BGetRolesById[0].profilePhoto
          : null
        : this.state.B2BGetRolesById?.length > 0
        ? this.state.B2BGetRolesById[0].profilePhoto
        : null
    );
    formVars.profile_265355_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BGetRolesById !== undefined
        ? stateVars.B2BGetRolesById?.length > 0
          ? stateVars.B2BGetRolesById[0].customerCode
          : null
        : this.state.B2BGetRolesById?.length > 0
        ? this.state.B2BGetRolesById[0].customerCode
        : null
    );
    formVars.profile_165336_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BGetRolesById !== undefined
        ? stateVars.B2BGetRolesById?.length > 0
          ? stateVars.B2BGetRolesById[0].fullName
          : null
        : this.state.B2BGetRolesById?.length > 0
        ? this.state.B2BGetRolesById[0].fullName
        : null
    );
    formVars.profile_557255_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BGetRolesById !== undefined
        ? stateVars.B2BGetRolesById?.length > 0
          ? stateVars.B2BGetRolesById[stateVars.B2BGetRolesById.length - 1]
              .userName
          : null
        : this.state.B2BGetRolesById?.length > 0
        ? this.state.B2BGetRolesById[this.state.B2BGetRolesById.length - 1]
            .userName
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProfilePageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProfilePageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.profile_299355_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BGetRolesById !== undefined
        ? stateVars.B2BGetRolesById?.length > 0
          ? stateVars.B2BGetRolesById[0].profilePhoto
          : null
        : this.state.B2BGetRolesById?.length > 0
        ? this.state.B2BGetRolesById[0].profilePhoto
        : null
    );

    formVars.profile_265355_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BGetRolesById !== undefined
        ? stateVars.B2BGetRolesById?.length > 0
          ? stateVars.B2BGetRolesById[0].customerCode
          : null
        : this.state.B2BGetRolesById?.length > 0
        ? this.state.B2BGetRolesById[0].customerCode
        : null
    );

    formVars.profile_165336_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BGetRolesById !== undefined
        ? stateVars.B2BGetRolesById?.length > 0
          ? stateVars.B2BGetRolesById[0].fullName
          : null
        : this.state.B2BGetRolesById?.length > 0
        ? this.state.B2BGetRolesById[0].fullName
        : null
    );

    formVars.profile_557255_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BGetRolesById !== undefined
        ? stateVars.B2BGetRolesById?.length > 0
          ? stateVars.B2BGetRolesById[stateVars.B2BGetRolesById.length - 1]
              .userName
          : null
        : this.state.B2BGetRolesById?.length > 0
        ? this.state.B2BGetRolesById[this.state.B2BGetRolesById.length - 1]
            .userName
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  ProfileComponent_144084_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProfileComponent_815392_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.PhotosFromGallery = (
      (await ReactSystemFunctions.getPhotosFromGallery(
        false,
        ReactSystemFunctions.convertToTypeByName("medium", "string")
      )) as any
    ).data;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProfileComponent_815392_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  ProfileComponent_815392_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      KUserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      Photo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.PhotosFromGallery !== undefined
            ? stateVars.PhotosFromGallery?.length > 0
              ? stateVars.PhotosFromGallery[0].dataBase64
              : null
            : this.state.PhotosFromGallery?.length > 0
            ? this.state.PhotosFromGallery[0].dataBase64
            : null
        ),
        "string"
      ),
    };

    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.PhotosFromGallery !== undefined
            ? stateVars.PhotosFromGallery?.length > 0
              ? stateVars.PhotosFromGallery[0].dataBase64
              : null
            : this.state.PhotosFromGallery?.length > 0
            ? this.state.PhotosFromGallery[0].dataBase64
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "Profile/ProfileComponent_815392_onClick1_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.SetProfilePhoto = result?.data.setProfilePhoto;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.ProfileComponent_815392_onClick2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.ProfileComponent_815392_onClick2_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProfileComponent_815392_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Profile/ProfileComponent_815392_onClick2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BGetRolesById = result?.data.b2BGetRolesById;
    formVars.profile_299355_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BGetRolesById !== undefined
        ? stateVars.B2BGetRolesById?.length > 0
          ? stateVars.B2BGetRolesById[0].profilePhoto
          : null
        : this.state.B2BGetRolesById?.length > 0
        ? this.state.B2BGetRolesById[0].profilePhoto
        : null
    );
    formVars.profile_265355_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BGetRolesById !== undefined
        ? stateVars.B2BGetRolesById?.length > 0
          ? stateVars.B2BGetRolesById[0].customerCode
          : null
        : this.state.B2BGetRolesById?.length > 0
        ? this.state.B2BGetRolesById[0].customerCode
        : null
    );
    formVars.profile_165336_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BGetRolesById !== undefined
        ? stateVars.B2BGetRolesById?.length > 0
          ? stateVars.B2BGetRolesById[0].fullName
          : null
        : this.state.B2BGetRolesById?.length > 0
        ? this.state.B2BGetRolesById[0].fullName
        : null
    );
    formVars.profile_557255_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BGetRolesById !== undefined
        ? stateVars.B2BGetRolesById?.length > 0
          ? stateVars.B2BGetRolesById[stateVars.B2BGetRolesById.length - 1]
              .userName
          : null
        : this.state.B2BGetRolesById?.length > 0
        ? this.state.B2BGetRolesById[this.state.B2BGetRolesById.length - 1]
            .userName
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProfileComponent_815392_onClick3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProfileComponent_815392_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.profile_299355_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BGetRolesById !== undefined
        ? stateVars.B2BGetRolesById?.length > 0
          ? stateVars.B2BGetRolesById[0].profilePhoto
          : null
        : this.state.B2BGetRolesById?.length > 0
        ? this.state.B2BGetRolesById[0].profilePhoto
        : null
    );

    formVars.profile_265355_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BGetRolesById !== undefined
        ? stateVars.B2BGetRolesById?.length > 0
          ? stateVars.B2BGetRolesById[0].customerCode
          : null
        : this.state.B2BGetRolesById?.length > 0
        ? this.state.B2BGetRolesById[0].customerCode
        : null
    );

    formVars.profile_165336_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BGetRolesById !== undefined
        ? stateVars.B2BGetRolesById?.length > 0
          ? stateVars.B2BGetRolesById[0].fullName
          : null
        : this.state.B2BGetRolesById?.length > 0
        ? this.state.B2BGetRolesById[0].fullName
        : null
    );

    formVars.profile_557255_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BGetRolesById !== undefined
        ? stateVars.B2BGetRolesById?.length > 0
          ? stateVars.B2BGetRolesById[stateVars.B2BGetRolesById.length - 1]
              .userName
          : null
        : this.state.B2BGetRolesById?.length > 0
        ? this.state.B2BGetRolesById[this.state.B2BGetRolesById.length - 1]
            .userName
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProfileComponent_819566_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      Id_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "d1bb6316_3119_9e61_9c0a_612641422869_confirmation",
        this.defaultML,
        "Profilinizi Silmek İstiyor musunuz?"
      ),
      "poppins",
      "Confirmation",
      "confirmation",
      "#246dff"
    );

    if (stateVars.Confirm) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "Profile/ProfileComponent_819566_onClick",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.DeleteProfileImage = result?.data.deleteProfileImage;
      stateVars.B2BGetRolesById = result?.data.b2BGetRolesById;
      formVars.profile_299355_value = ReactSystemFunctions.toString(
        this,
        stateVars.B2BGetRolesById !== undefined
          ? stateVars.B2BGetRolesById?.length > 0
            ? stateVars.B2BGetRolesById[0].profilePhoto
            : null
          : this.state.B2BGetRolesById?.length > 0
          ? this.state.B2BGetRolesById[0].profilePhoto
          : null
      );
      formVars.profile_265355_value = ReactSystemFunctions.toString(
        this,
        stateVars.B2BGetRolesById !== undefined
          ? stateVars.B2BGetRolesById?.length > 0
            ? stateVars.B2BGetRolesById[0].customerCode
            : null
          : this.state.B2BGetRolesById?.length > 0
          ? this.state.B2BGetRolesById[0].customerCode
          : null
      );
      formVars.profile_165336_value = ReactSystemFunctions.toString(
        this,
        stateVars.B2BGetRolesById !== undefined
          ? stateVars.B2BGetRolesById?.length > 0
            ? stateVars.B2BGetRolesById[0].fullName
            : null
          : this.state.B2BGetRolesById?.length > 0
          ? this.state.B2BGetRolesById[0].fullName
          : null
      );
      formVars.profile_557255_value = ReactSystemFunctions.toString(
        this,
        stateVars.B2BGetRolesById !== undefined
          ? stateVars.B2BGetRolesById?.length > 0
            ? stateVars.B2BGetRolesById[stateVars.B2BGetRolesById.length - 1]
                .userName
            : null
          : this.state.B2BGetRolesById?.length > 0
          ? this.state.B2BGetRolesById[this.state.B2BGetRolesById.length - 1]
              .userName
          : null
      );
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.ProfileComponent_819566_onClick1_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProfileComponent_819566_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.profile_299355_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BGetRolesById !== undefined
        ? stateVars.B2BGetRolesById?.length > 0
          ? stateVars.B2BGetRolesById[0].profilePhoto
          : null
        : this.state.B2BGetRolesById?.length > 0
        ? this.state.B2BGetRolesById[0].profilePhoto
        : null
    );

    formVars.profile_265355_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BGetRolesById !== undefined
        ? stateVars.B2BGetRolesById?.length > 0
          ? stateVars.B2BGetRolesById[0].customerCode
          : null
        : this.state.B2BGetRolesById?.length > 0
        ? this.state.B2BGetRolesById[0].customerCode
        : null
    );

    formVars.profile_165336_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BGetRolesById !== undefined
        ? stateVars.B2BGetRolesById?.length > 0
          ? stateVars.B2BGetRolesById[0].fullName
          : null
        : this.state.B2BGetRolesById?.length > 0
        ? this.state.B2BGetRolesById[0].fullName
        : null
    );

    formVars.profile_557255_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BGetRolesById !== undefined
        ? stateVars.B2BGetRolesById?.length > 0
          ? stateVars.B2BGetRolesById[stateVars.B2BGetRolesById.length - 1]
              .userName
          : null
        : this.state.B2BGetRolesById?.length > 0
        ? this.state.B2BGetRolesById[this.state.B2BGetRolesById.length - 1]
            .userName
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.ProfilePageInit();
    }
  }
}
